import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { archiveClient } from '../api/clients.api';

export const useArchiveClient = ({
  clientId,
  onSuccess,
}: {
  clientId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.clients');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: () => archiveClient(clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['clients', clientId] });
      displayToastSuccess(t('authenticated.clients:toasts.clientArchivedSuccess'));

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.clients:toasts.archiveClientError'
      );
    },
  });
};
